import { Button, Grid, IconButton, styled, Theme, createStyles, makeStyles } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

export const MainCont = styled('div')({
  display: 'flex',
  flexDirection: 'column',

  '& > div:not(:last-child)': {
    marginBottom: 20,
  },

  '& .MuiOutlinedInput-root': {
    height: '50px!important',
    fontSize: 14,
    background: '#0e1319',
  },

  '& .MuiFormLabel-root': {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    letterSpacing: '1px',
    alignItems: 'center',
    color: '#c2ccd8',

    '& .MuiBox-root': {
      padding: '2px 4px 1px 5px',
      border: '1px solid',
      borderRadius: '100%',
      fontSize: '12px',
    },
  },

  '& .MuiSelect-iconOutlined': {
    right: '0',
    top: '22px',
  },

  '& .MuiSelect-iconOpen': {
    top: '2px',
    right: '13px',
  },
});

export const Heading = styled(Typography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  position: 'relative',
  // borderBottom: '1px solid #2d343e',
  borderBottom: '1px solid',
  borderBottomColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  alignItems: 'center',
  paddingBottom: 20,
  margin: '10px 0 30px',

  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
}));

export const Column = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '2em',

  [theme.breakpoints.down(900)]: {
    flexDirection: 'column',
  },
}));

export const ContactColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '2em',
  '& > div': {
    width: '50%',
  },

  [theme.breakpoints.down(1500)]: {
    flexDirection: 'column',

    '& > div': {
      width: '100%',
    },
  },
}));

export const CheckboxContainer = styled(Grid)({
  letterSpacing: 0.4,
  marginTop: 10,

  '& .MuiTypography-root': {
    fontSize: 15,
  },
});

export const IndependentRow = styled(Grid)<Theme, { $isChecked?: boolean }>(({ theme, $isChecked }) => ({
  opacity: $isChecked ? 0.4 : 1,
  marginTop: 15,
  '& > div': {
    width: 311,
  },
  [theme.breakpoints.down('xs')]: {
    '& > div': {
      width: '100%',
    },
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  height: '50px !important',
  textTransform: 'unset',
  textDecoration: 'none!important',
  width: 311,
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
}));

export const TwoColumn = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 25,
  width: '100%',

  '& > div': {
    flex: '50%',
    '&:first-child > div > div:last-child': {
      marginTop: 10,
    },
  },

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const LocationContainer = styled('div')<Theme, { $isEmpty?: boolean }>(({ $isEmpty = false, theme }) => ({
  background: theme.palette.type === 'dark' ? '#0e1319' : COLORS.WHITE,
  // border: '1px solid #2d343e',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  marginTop: 10,
  borderRadius: 5,
  height: 50,
  display: 'flex',
  justifyContent: $isEmpty ? 'center' : 'space-between',
  alignItems: 'center',
  padding: '15px 13px',
}));

export const LocationActions = styled('div')({
  display: 'flex',
  gap: 5,
});

export const CustomIconButton = styled(IconButton)({
  width: 30,
  height: 30,

  '& svg': {
    width: 18,
  },
});

export const AddNewLocationButton = styled(Button)({
  marginTop: 10,
  height: '50px !important',

  background: 'transparent',
  border: '1px solid #2d343e',
});

export const ChipsContainer = styled(Grid)({
  '& .MuiChip-label': {
    marginTop: 2,
  },

  '& .MuiChip-root': {
    margin: '0 5px 5px 0',
    background: '#151b24',
    borderRadius: 8,
    height: 36,
  },

  '& svg': {
    marginLeft: 15,
  },
});

export const OneColumnGrid = styled(Grid)<Theme, { $gutter?: number }>(({ $gutter, theme }) => ({
  width: `calc(100% - ${$gutter}px)`,

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(1, 100%)',
    width: '100%',
  },
}));

export const TwoColumnGrid = styled(Grid)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 50%)',
  rowGap: 15,
  columnGap: 25,
  width: 'calc(100% - 25px)',

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(1, 100%)',
    width: '100%',
  },
}));

export const TwoColumn6Grid = styled(Grid)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 50%)',
  columnGap: 15,
  width: 'calc(100% - 40px)',

  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(1, 100%)',
    width: '100%',
  },
}));

export const FlexContainer = styled(Grid)({
  marginTop: 15,
  display: 'flex',
  gap: 20,
  alignItems: 'center',
});

export const ContactInfoContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down(1600)]: {
    width: '100%',
  },
}));

// New Styles
export const useStyles = makeStyles((theme) =>
  createStyles({
    textInputStyle: {
      backgroundColor: (theme.palette.type === 'dark' ? COLORS.DARK : COLORS.WHITE) + ' !important',
    },
    select: {
      backgroundColor: 'transparent !important',
      '& .MuiSelect-icon': {
        color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
        top: 15,
        right: 12,
      },
    },
  }),
);
